export const SUMMARY_CARDS_COLUMNS = 3;
